import { Button, Space, Tag } from "antd";
import { BiFilterAlt } from "react-icons/bi";

export type ActiveFilterEntry = {
  key: string;
  fieldLabel: string;
  valueText: string;
};

export type ActiveFilterChipsBarProps = {
  show: boolean;
  entries: ActiveFilterEntry[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
};

export function ActiveFilterChipsBar({
  show,
  entries,
  onRemove,
  onClearAll,
}: ActiveFilterChipsBarProps) {
  if (!show || entries.length === 0) return null;
  return (
    <div className="app-filter-bar">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 8,
          rowGap: 10,
        }}
      >
        <span
          className="app-filter-title"
          style={{ marginBottom: 0, flexShrink: 0 }}
        >
          <BiFilterAlt style={{ fontSize: 14 }} />
          Active filters
        </span>
        <Space size={[8, 8]} wrap style={{ flex: 1, minWidth: 0 }}>
          {entries.map(({ key, fieldLabel, valueText }) => (
            <Tag
              key={key}
              closable
              onClose={(e) => {
                e.preventDefault();
                onRemove(key);
              }}
              style={{ marginInlineEnd: 0 }}
              color="purple"
            >
              {fieldLabel}: {valueText}
            </Tag>
          ))}
        </Space>
        <Button
          type="link"
          className="text-primary weight-600"
          size="small"
          onClick={onClearAll}
        >
          Clear all
        </Button>
      </div>
    </div>
  );
}
